<mat-dialog-content class="d-flex flex-col">
    <div class="flex-row flex-space-between">
        <div>
            <mat-card-header class="p-0">
                <mat-card-title>
                    <h3 class="m-0" mat-dialog-title>{{ title }}</h3>
                </mat-card-title>
            </mat-card-header>
        </div>
        <div class="float-end">
            <button (click)="this.dialogRef.close();" (keyup.enter)="this.dialogRef.close();" aria-label="Close window"
                    class="mat-dialog-close"
                    mat-dialog-close mat-icon-button
                    matTooltip="Close Window">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    @if (permissions && this.id && this.userId) {
        <app-manage-access-table [canRequest]="true" [child]="userId"
                                 [myMemoryBox]="true"
                                 [permissions]="permissions"
                                 [timelineName]="title"
                                 [timeline]="this.id"></app-manage-access-table>
    }
</mat-dialog-content>
